export default {
   floorList:'/wechatapp/buildingHouse/firstApproveDepartment/listApproveDepartment', 
   delFloor:'wechatapp/buildingHouse/firstApproveDepartment/del', //
   addFloor:'/wechatapp/buildingHouse/firstApproveDepartment/save',
   getSelect:'/wechatapp/buildingHouse/firstApproveDepartment/listDepartment'
}